import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SSCI = () => {
    const [membershipType, setMembershipType] = useState('Associate');
    const [membershipId, setMembershipId] = useState('');
    const [consumerInfo, setConsumerInfo] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    // Prices based on membership type
    const prices = {
        Associate: {
            classFee: 3700,
            idCard: 500
        },
        Corporate: {
            classFee: 5950,
            idCard: 500
        }
    };

    // Calculate total amount
    const calculateTotal = () => {
        let total = prices[membershipType].classFee;
        if (selectedItems.includes('idCard')) {
            total += prices[membershipType].idCard;
        }
        return total;
    };

    // Handle membership info fetch
    const handleGetInfo = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Remove prefixes if present
            const cleanMembershipId = membershipId.replace(/[A-C]-/g, '');

            const response = await axios.post('https://api.paypro.com.pk/cpay/gcd', {
                userName: membershipType === 'Associate' ? 'SCCI_Ass' : 'SCCI_Corp',
                password: membershipType === 'Associate' ? 'Live@sa24' : 'Live@sc24',
                fullConsumerCode: `1752${cleanMembershipId}`
            });

            const data = response.data;

            if (data[0]?.Status !== '00') {
                throw new Error(data[0]?.Description || 'Incorrect membership number. Please ensure you are entering the correct membership number corresponding to your membership type, or email us at sialkot@scci.com.pk for further assistance.');
            }

            setConsumerInfo(data[1]);
            setEmail(data[1].Email || '');
            setPhone(data[1].Mobile || '');
            // Class fee is always selected by default
            setSelectedItems(['classFee']);
        } catch (err) {
            setError(err.message || 'An error occurred while fetching membership information.');
        } finally {
            setLoading(false);
        }
    };

    // Handle payment submission
    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const totalAmount = calculateTotal();
            const billDetails = [
                { 'New Registration Fee': prices[membershipType].classFee },
            ];

            if (selectedItems.includes('idCard')) {
                billDetails.push({ 'Other Fee and Services Charges': prices[membershipType].idCard });
            }

            const credentials = {
                MerchantId: membershipType === 'Associate' ? 'SCCI_Ass' : 'SCCI_Corp',
                MerchantPassword: membershipType === 'Associate' ? 'Live@sa24' : 'Live@sc24'
            };

            const orderData = {
                ...credentials,
                OrderNumber: Math.floor(Math.random() * 1000000),
                OrderAmount: totalAmount,
                IssueDate: new Date().toLocaleDateString('en-GB'),
                OrderDueDate: '05/05/2025',
                OrderType: "Service",
                "Membership No": consumerInfo.ConsumerCode,
                ReusableConsumerId: consumerInfo.FullConsumerCode,
                CustomerName: consumerInfo.Name,
                CustomerMobile: phone || consumerInfo.Mobile,
                CustomerEmail: email || consumerInfo.Email,
                CustomerAddress: consumerInfo.Address || '',
                BillDetail01: {
                    'New Registration Fee': prices[membershipType].classFee,
                    'Other Fee and Services Charges': selectedItems.includes('idCard') ? prices[membershipType].idCard : 0
                }
            };

            const response = await axios.post(
                'https://api.paypro.com.pk/cpay/co',
                null,
                {
                    params: {
                        oJson: JSON.stringify([credentials, orderData])
                    }
                }
            );

            const result = response.data;

            if (result[0]?.Status === '00') {
                // Redirect to payment page
                window.location.href = `https://marketplace.paypro.com.pk/pyb?bid=${btoa(result[1].ConnectPayId)}`;
            } else {
                throw new Error(result[1]?.Description || 'Error occurred in invoice creation');
            }
        } catch (err) {
            setError(err.message || 'An error occurred while processing your payment.');
            setLoading(false);
        }
    };

    // Toggle checkbox selection
    const handleCheckboxChange = (item) => {
        if (item === 'classFee') return; // Class fee cannot be deselected

        setSelectedItems(prev =>
            prev.includes(item)
                ? prev.filter(i => i !== item)
                : [...prev, item]
        );
    };

    // Reset form when membership type changes
    useEffect(() => {
        setConsumerInfo(null);
        setError('');
        setSelectedItems(['classFee']);
    }, [membershipType]);

    return (
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>THE SIALKOT CHAMBER OF COMMERCE & INDUSTRY</h1>

            {!consumerInfo ? (
                <form onSubmit={handleGetInfo} style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                            Membership Type*
                        </label>
                        <select
                            value={membershipType}
                            onChange={(e) => setMembershipType(e.target.value)}
                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
                            required
                        >
                            <option value="Associate">Associate</option>
                            <option value="Corporate">Corporate</option>
                        </select>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                            Enter Your Membership ID*
                        </label>
                        <input
                            type="text"
                            value={membershipId}
                            onChange={(e) => setMembershipId(e.target.value)}
                            placeholder="Membership ID"
                            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        style={{
                            background: '#0e0795',
                            color: 'white',
                            padding: '12px 20px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            margin: '0 auto'
                        }}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span>Loading...</span>
                                <div style={{ width: '20px', height: '20px' }}>
                                    <img src="https://billing.paypro.com.pk/wp-content/uploads/2024/04/ZNeT.gif" alt="Loading" style={{ width: '100%', height: '100%' }} />
                                </div>
                            </>
                        ) : (
                            'Get Info'
                        )}
                    </button>

                    {error && (
                        <div style={{ color: 'red', marginTop: '15px', textAlign: 'center' }}>
                            {error}
                        </div>
                    )}
                </form>
            ) : (
                <form onSubmit={handlePaymentSubmit} style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                        <div style={{ flex: '1 1 45%', minWidth: '200px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                                Membership No
                            </label>
                            <input
                                type="text"
                                value={consumerInfo.ConsumerCode}
                                readOnly
                                disabled
                                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', background: '#eee' }}
                            />
                        </div>

                        <div style={{ flex: '1 1 45%', minWidth: '200px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                                Email Address
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
                            />
                        </div>

                        <div style={{ flex: '1 1 45%', minWidth: '200px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                                Phone Number
                            </label>
                            <input
                                type="tel"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
                            />
                        </div>

                        <div style={{ flex: '1 1 45%', minWidth: '200px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                                Company Name
                            </label>
                            <input
                                type="text"
                                value={consumerInfo.Name}
                                readOnly
                                disabled
                                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', background: '#eee' }}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                            <div style={{ fontSize: '24px', fontWeight: 'bold', padding: '10px' }}>
                                {membershipType} Class
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', padding: '5px' }}>
                                Renewal Dues For the Year 2024-25
                            </div>
                        </div>

                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                <tr>
                                    <th style={{ fontSize: '16px', textDecoration: 'underline', textDecorationThickness: '2px', padding: '10px', textAlign: 'left' }}>
                                        PARTICULARS
                                    </th>
                                    <th style={{ fontSize: '16px', textDecoration: 'underline', textDecorationThickness: '2px', padding: '10px', textAlign: 'center' }}>
                                        AMOUNT
                                    </th>
                                    <th style={{ fontSize: '16px', textDecoration: 'underline', textDecorationThickness: '2px', padding: '10px', textAlign: 'center' }}>
                                        SELECT
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td style={{ padding: '10px' }}>Class Fee</td>
                                    <td style={{ padding: '10px', textAlign: 'center' }}>{prices[membershipType].classFee}</td>
                                    <td style={{ padding: '10px', textAlign: 'center', pointerEvents: 'none' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes('classFee')}
                                            onChange={() => handleCheckboxChange('classFee')}
                                            disabled
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px' }}>Membership ID Card <strong>(Optional)</strong></td>
                                    <td style={{ padding: '10px', textAlign: 'center' }}>{prices[membershipType].idCard}</td>
                                    <td style={{ padding: '10px', textAlign: 'center' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes('idCard')}
                                            onChange={() => handleCheckboxChange('idCard')}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', fontWeight: '700' }}>Total Amount</td>
                                    <td colSpan="2" style={{ padding: '10px', textAlign: 'center', fontWeight: '600' }}>
                                        PKR {calculateTotal()}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <button
                            type="submit"
                            style={{
                                background: '#0e0795',
                                color: 'white',
                                padding: '12px 24px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span>Processing...</span>
                                    <div style={{ width: '20px', height: '20px' }}>
                                        <img src="https://billing.paypro.com.pk/wp-content/uploads/2024/04/ZNeT.gif" alt="Loading" style={{ width: '100%', height: '100%' }} />
                                    </div>
                                </>
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>

                    {error && (
                        <div style={{ color: 'red', marginTop: '15px', textAlign: 'center' }}>
                            {error}
                        </div>
                    )}
                </form>
            )}
        </div>
    );
};

export default SSCI;